import { SearchScope } from './types';

const SCOPE_LANGUAGELEARNING = 'LANGUAGE_LEARNING';
const SCOPE_LANGUAGELEARNING_REQUESTKEY = 'LANGUAGE_LEARNING';
const SCOPE_LANGUAGELEARNING_NAME = 'Language Learning';
const SCOPE_CATALOGUE = 'catalogue';
const SCOPE_CATALOGUE_REQUESTKEY = 'CATALOGUE';
const SCOPE_CATALOGUE_NAME = 'Catalogue';
export const SCOPE_CATALOGUE_OBJECT: SearchScope = {
    requestKey: SCOPE_CATALOGUE_REQUESTKEY,
    key: SCOPE_CATALOGUE,
    name: SCOPE_CATALOGUE_NAME
};
const SCOPE_LOTE_KEY = 'LOTE';
const SCOPE_LOTE_NAME = 'LOTE';
const SCOPE_LOTE_REQUESTKEY = 'LOTE';
export const SCOPE_LOTE_OBJECT: SearchScope = {
    requestKey: SCOPE_LOTE_REQUESTKEY,
    key: SCOPE_LOTE_KEY,
    name: SCOPE_LOTE_NAME
};
export const SCOPE_LANGUAGELEARNING_OBJECT: SearchScope = {
    requestKey: SCOPE_LANGUAGELEARNING_REQUESTKEY,
    key: SCOPE_LANGUAGELEARNING,
    name: SCOPE_LANGUAGELEARNING_NAME
};
const SCOPE_ALL_REQUESTKEY = 'ALL';
const SCOPE_ALL_KEY = 'ALL';
const SCOPE_ALL_NAME = 'All Formats';
export const SCOPE_ALL_OBJECT: SearchScope = {
    requestKey: SCOPE_ALL_REQUESTKEY,
    key: SCOPE_ALL_KEY,
    name: SCOPE_ALL_NAME
};
const SCOPE_EBOOK_REQUESTKEY = 'EBOOKS';
const SCOPE_EBOOK_KEY = 'EBOOKS';
const SCOPE_EBOOK_NAME = 'eBooks';
export const SCOPE_EBOOK_OBJECT: SearchScope = {
    requestKey: SCOPE_EBOOK_REQUESTKEY,
    key: SCOPE_EBOOK_KEY,
    name: SCOPE_EBOOK_NAME
};
const SCOPE_EAUDIOBOOKS_REQUESTKEY = 'EAUDIOBOOKS';
const SCOPE_EAUDIOBOOKS_KEY = 'EAUDIOBOOKS';
const SCOPE_EAUDIOBOOKS_NAME = 'eAudiobooks';
export const SCOPE_EAUDIOBOOK_OBJECT: SearchScope = {
    requestKey: SCOPE_EAUDIOBOOKS_REQUESTKEY,
    key: SCOPE_EAUDIOBOOKS_KEY,
    name: SCOPE_EAUDIOBOOKS_NAME
};
const SCOPE_EPRESS_REQUESTKEY = 'EPRESS';
const SCOPE_EPRESS_KEY = 'EPRESS';
const SCOPE_EPRESS_NAME = 'ePress';
export const SCOPE_EPRESS_OBJECT: SearchScope = {
    requestKey: SCOPE_EPRESS_REQUESTKEY,
    key: SCOPE_EPRESS_KEY,
    name: SCOPE_EPRESS_NAME
};

export function isCatalogueSearchScope(searchScope: SearchScope) {
    switch (searchScope.key) {
        case SCOPE_EAUDIOBOOKS_KEY:
        case SCOPE_EBOOK_KEY:
        case SCOPE_EPRESS_KEY:
        case SCOPE_LOTE_KEY:
        case SCOPE_LANGUAGELEARNING:
        case SCOPE_CATALOGUE:
            return true;
        default:
            return false;
    }
}
